import React, { ChangeEvent } from 'react';
import { InputAdornment, TextField } from '@mui/material';
import { makeStyles } from '~/UIKit/Style';
import { Search } from '@mui/icons-material';
import {
  PLAIN_GREY,
  combinedColor,
  OPACITY_MEDIUM,
  DARKER_GREY,
  VERTICAL_SEPARATOR,
  ACTION_TOOLBAR_BACKGROUND,
} from '~/Constants/Colors.constants';
import { FONT_SIZE_MEDIUM_CONFUSED } from '~/Constants/UI.constants';

export interface IntegrationFilterProps {
  id?: string;
  placeholder: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  value?: string | number;
  autoFocus?: boolean;
}

const useStyles = makeStyles((theme) => ({
  searchWrapper: {
    display: 'flex',
    alignItems: 'center',
    columnGap: 16,
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  searchInput: {
    height: 28,
    marginTop: 1,
    width: '100%',
    borderRadius: '25px',
    color: DARKER_GREY,
    fontSize: '12px',
    lineHeight: '16px',
    padding: '5px',
    '& .MuiOutlinedInput-root': {
      paddingLeft: '8px',
      '& svg': {
        fontSize: FONT_SIZE_MEDIUM_CONFUSED,
        color: VERTICAL_SEPARATOR,
      },
      '& input': {
        padding: 0,
        width: 'fill-available',
        letterSpacing: 0.5,
      },
      '& fieldset': {
        borderColor: combinedColor(PLAIN_GREY, OPACITY_MEDIUM),
      },
    },
  },
  searchInputContainer: {
    width: 295,
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  container: {
    display: 'grid',
    gridTemplateColumns: 'max-content max-content',
    justifyContent: 'space-between',
    position: 'sticky',
    justifyItems: 'end',
    background: ACTION_TOOLBAR_BACKGROUND,
    marginBottom: 34,
    marginTop: 1,
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: '1fr',
      rowGap: 20,
      margin: '0 16px 20px',
    },
  },
  searchIcon: {
    color: VERTICAL_SEPARATOR,
    fontSize: FONT_SIZE_MEDIUM_CONFUSED,
  },
}));

export const IntegrationFilterInput = ({
  id,
  placeholder,
  onChange,
  value,
  autoFocus = false,
}: IntegrationFilterProps) => {
  const { classes } = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.searchWrapper}>
        <TextField
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search className={classes.searchIcon} />
              </InputAdornment>
            ),
            classes: {
              root: classes.searchInput,
            },
          }}
          className={classes.searchInputContainer}
          id={id}
          onChange={onChange}
          placeholder={placeholder}
          variant="outlined"
          value={value}
          autoFocus={autoFocus}
        />
      </div>
    </div>
  );
};
